import React from "react";
import { DatePicker } from "antd";
const { RangePicker } = DatePicker;

const Calender = ({ handleChange, defaultValue, value }) => {
  return (
    <RangePicker
      onChange={handleChange}
      defaultValue={defaultValue}
      value={value}
      format="DD-MM-YYYY"
      style={{ width: '100%' ,
      height: 38, 
      borderRadius: 12,
      }}
    />
  );
};

export { Calender };
